import React from 'react'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Text from '@material-ui/core/Typography';
import {paintTotals} from '../../features/colorgenerator';

function TotalsStats({total = 2, title = ''}) {
    const absTotal = Math.abs(total)
    const arrowNumbers = absTotal === 0 ? 0 : absTotal <= 10 ? 1 : absTotal <= 20 ? 2 : absTotal >= 30 ? 3 : 2
    const currentColor = paintTotals(total);

    const Icon = total > 0 ? KeyboardArrowUpIcon : KeyboardArrowDownIcon

  return (
    <div>
        {title}
    <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
        <Text variant="h4">
            {total}
        </Text>
        <div style={{display: 'flex', flexDirection: 'column'}}>
            {Array(arrowNumbers).fill(4).map(() => <Icon style={ {color: currentColor, margin: '-0.6rem', fontSize: '2rem'} } />)}
        </div>
    </div>
    <Text variant="p">
        {total === 0 ? '' : total > 0 ? 'Больше' : 'Меньше'} 
    </Text>
    </div>
  )
}

export default TotalsStats;
